import { render, staticRenderFns } from "./ApprovalOwnerModal.vue?vue&type=template&id=a921bd64&scoped=true"
import script from "./ApprovalOwnerModal.vue?vue&type=script&lang=js"
export * from "./ApprovalOwnerModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalOwnerModal.vue?vue&type=style&index=0&id=a921bd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a921bd64",
  null
  
)

export default component.exports